<script>

export default {
  props: {

  },
  components: {

  },
  data() {
    return {
      transactionData: null,
      transaction_code: '',
      roundId: '',
      openDialog: false,
      content: 'retouch',
      editForm: {
        transactionKey: '',
        type: '',
        amount: 0,
        afterAmount: 0,
      },
      editDetail: {
        betAmount: 0,
        winAmount: 0,
        target: ""
      },
      bets: []
    }
  },

  mounted() {

  },
  watch: {

  },
  methods: {
    onHidden() {
      this.openDialog = false;  // 수동 초기화
      this.$emit('cancel');     // 부모에게 닫힘 알림
    },

    open: function(obj, page = 'retouch') {
      const data = obj.data;
      const bets = obj.result?.detail?.bets || [];

      // 모달 내용 세팅
      this.content = page;
      this.transactionData = data;

      this.roundId = data.siteRoundId
      this.transaction_code = data.data.transaction_code

      this.editForm.transactionKey = data.transactionKey;
      this.editForm.type = data.type;
      this.editForm.amount = data.amount;
      this.editForm.afterAmount = data.afterAmount;

      // this.bets = bets;
      this.bets = JSON.parse(JSON.stringify(bets));

      this.openDialog = true;
    },
    refresh: function() {
      alert('데이터 새로 고침')
    },

    async saveTransactionChange() {
      try {
          const payload = {
            transactionKey: this.transactionData.transactionKey,
            type: this.editForm.type,
            amount: this.editForm.amount,
            afterAmount: this.editForm.afterAmount
          }

          const response = await this.$API.transaction.modifyTransaction(payload)
          if(response?.result === 1) {
            alert(`베팅내역이 수정되었습니다.`)
            this.transactionData.type = payload.type
            this.transactionData.amount = payload.amount
            this.transactionData.afterAmount = payload.afterAmount
          } else {
            alert(`베팅내역 수정 중 오류가 발생했습니다.${payload}`)

          }
      } catch (err) {
          console.error(err)
          this.$toast.error('요청 중 오류가 발생했습니다.')
      }
    },

    async saveTransactionDetailChange() {
      if (this.bets.length === 0) {
        alert(`베팅 상세 데이터가 없습니다.`)
        return
      }
      try {
        const payload = {
          transactionKey: this.transactionData.parentTransactionKey,
          bets: this.bets.map(bet => ({
            target: bet.target,
            betAmount: bet.betAmount,
            winAmount: bet.winAmount
          }))
        }

        const response = await this.$API.transaction.modifyTransactionDetail(payload)
        if(response?.result === 1) {
          alert(`베팅내역이 수정되었습니다.`)

          if (this.transactionData.detail?.bets) {
            this.transactionData.detail.bets = this.transactionData.detail.bets.map(originalBet => {
              const updated = payload.bets.find(b => b.target === originalBet.target);
              return updated ? { ...originalBet, ...updated } : originalBet;
            });
          }
        } else {
          alert(`베팅내역 수정 중 오류가 발생했습니다.${payload}`)
        }
      } catch (err) {
        console.error(err)
        this.$toast.error('요청 중 오류가 발생했습니다.')
      }
    }

  }
};
</script>

<style>

  option[disabled] {
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #ccc;
  }

  .border-end {
    border-right: 1px solid #919396 !important;
  }
</style>

<template>
  <b-modal
    title="데이터 보정"
    v-model="openDialog"
    size="xl"
    scrollable
    button-size="sm"
    @hidden="onHidden"
  >
    <div class="d-block" v-if="transactionData">
      <div class="card shadow shadow-sm">
        <div class="card-header pb-0">
        </div>


        <div class="m-3">
          <label class="form-label">거래 키 :
            <span class="badge-soft-success rounded-3 p-1">{{ transactionData.transactionKey }}</span>
          </label>
        </div>

        <div class="m-3">
          <label class="form-label">통합코드 :
            <span class="badge-soft-success rounded-3 p-1">{{ transaction_code }}</span>
          </label>
        </div>

        <div class="m-3">
          <label class="form-label">라운드키 :
            <span class="badge-soft-success rounded-3 p-1">{{ roundId }}</span>
          </label>
        </div>


        <div class="card-body">
          <div class="row mb-4">
            <h5 class="bg-info-subtle p-2 mb-4">{{ $t('당첨금액 수정') }}</h5>

            <!-- 변경 전 -->
            <div class="col-md-6 border-end">
              <div class="mb-3">
                <label class="form-label">당첨금액</label>
                <input type="number" class="form-control" :value="transactionData.amount" disabled />
              </div>
            </div>

            <!-- 변경 후 -->
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">수정할 당첨금액</label>
                <input type="number" class="form-control" v-model.number="editForm.amount" />
              </div>
            </div>


            <!-- 변경 전 -->
            <div class="col-md-6 border-end">
              <div class="mb-3">
                <label class="form-label">결과 타입</label>
                <input type="text" class="form-control" :value="transactionData.type" disabled />
              </div>
            </div>

            <!-- 변경 예정 -->
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">수정할 타입</label>
                <select class="form-select" v-model="editForm.type">
                  <option value="win"> 승 </option>
                  <option value="lose"> 패 </option>
                  <option value="cancel"> 취소 </option>
                </select>
              </div>
            </div>

            <!-- 변경 전 -->
            <div class="col-md-6 border-end">
              <div class="mb-3">
                <label class="form-label">이전 보유금</label>
                <input type="number" class="form-control" :value="transactionData.beforeAmount" disabled />
              </div>
            </div>

            <!-- 변경 예정 -->
            <div class="col-md-6">
              <div class="mb-3">
<!--                <input type="number" class="form-control" v-model.number="editForm.afterAmount" />-->
              </div>
            </div>

            <!-- 변경 전 -->
            <div class="col-md-6 border-end">
              <div class="mb-3">
                <label class="form-label">이후 보유금</label>
                <input type="number" class="form-control" :value="transactionData.afterAmount" disabled />
              </div>
            </div>

            <!-- 변경 예정 -->
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">수정할 이후 보유금</label>
                <input type="number" class="form-control" v-model.number="editForm.afterAmount" />
              </div>
            </div>

            <div class="text-end">
              <button class="btn btn-primary" @click="saveTransactionChange">수정</button>
            </div>
          </div>

          <hr>

          <div class="row mb-4">
            <h5 class="bg-info-subtle p-2 mb-4">{{ $t('배팅상세금액 수정') }}</h5>
            <!-- 베팅픽(패 데이터) -->
            <div class="col-md-6">

            </div>


            <!-- 베팅금(상세데이터 수정) -->
            <div class="col-md-6">
              <div class="mb-3" >
                <table class="table table-bordered table-sm mt-2">
                  <thead>
                  <tr>
                    <th>배팅 대상</th>
                    <th>배팅 금액</th>
                    <th>당첨 금액</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(betData, index) in bets" :key="index">
                    <td>{{ betData.target }}</td>
                    <!-- 배팅 금액 input -->

                    <td>
                      <input
                        type="number"
                        class="form-control form-control-sm"
                        v-model.number="betData.betAmount"
                        :placeholder="'0'"
                      />
                    </td>

                    <!-- 당첨 금액 input -->
                    <td>
                      <input
                        type="number"
                        class="form-control form-control-sm"
                        v-model.number="betData.winAmount"
                        :placeholder="'0'"
                      />
                    </td>
                  </tr>
                  </tbody>
                </table>

                <!-- bets가 없을 경우 메시지 -->
                <div v-if="bets.length === 0" class="text-muted">배팅 상세 데이터가 없습니다.</div>
              </div>

              <div class="text-end">
                <button class="btn btn-primary" v-show="bets.length !== 0" @click="saveTransactionDetailChange">수정</button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
